<template>
  <danger hide-icon title="Unsupported Browser">
    Your version of Office is using Internet Explorer as its browser. Sharedo
    does not support Internet Explorer. Please upgrade to a newer version of
    office that uses Edge as its browser.
  </danger>
</template>
<script>
import Danger from "@/components/common/banners/Danger.vue";

export default {
  components: { Danger },
};
</script>